import { createContext, type ReactNode, useContext } from 'react';

import { fromIsoDate, type IsoDate } from './parsers/date.ts';

/** Производственный календарь для полей дат: выходные, праздники, перенесённые рабочие дни. */
export interface WorkCalendar {
  /** Нерабочий день: выходной или праздник. */
  isDayOff(date: IsoDate): boolean;
}

/** Без производственного календаря нерабочие — суббота и воскресенье. */
export const WEEKENDS_ONLY: WorkCalendar = {
  isDayOff: (date) => {
    const day = fromIsoDate(date).getDay();
    return day === 0 || day === 6;
  },
};

const WorkCalendarContext = createContext<WorkCalendar>(WEEKENDS_ONLY);

/** Календарь студии (праздники РФ и переносы) для всех полей дат внутри. */
export function WorkCalendarProvider({
  calendar,
  children,
}: {
  calendar: WorkCalendar;
  children: ReactNode;
}) {
  return <WorkCalendarContext value={calendar}>{children}</WorkCalendarContext>;
}

export function useWorkCalendar(): WorkCalendar {
  return useContext(WorkCalendarContext);
}
